import {
  MDXEditor,
  headingsPlugin,
  listsPlugin,
  quotePlugin,
  thematicBreakPlugin,
  markdownShortcutPlugin,
  toolbarPlugin,
  BoldItalicUnderlineToggles,
  BlockTypeSelect,
  ListsToggle,
  UndoRedo,
} from '@mdxeditor/editor';
import '@mdxeditor/editor/style.css';
import { FieldProps, Labeled } from 'react-admin';
import { useController } from 'react-hook-form';

export type MarkdownFieldProps<
  RecordType extends Record<string, any> = Record<string, any>,
> = FieldProps<RecordType>;

export const MarkdownField = ({
  source,
  label,
}: MarkdownFieldProps) => {
  const { field } = useController({
    name: source!,
    defaultValue: '',
  });

  return (
    <Labeled label={label} fullWidth>
      <MDXEditor
        markdown={field.value || ''}
        onChange={(value) => field.onChange(value)}
        onBlur={field.onBlur}
        plugins={[
          headingsPlugin(),
          listsPlugin(),
          quotePlugin(),
          thematicBreakPlugin(),
          markdownShortcutPlugin(),
          toolbarPlugin({
            toolbarContents: () => (
              <>
                <UndoRedo />
                <BlockTypeSelect />
                <BoldItalicUnderlineToggles />
                <ListsToggle />
              </>
            ),
          }),
        ]}
      />
    </Labeled>
  );
};
